import axios from 'axios'
// import auth from '@/auth'
import store from '@/store'
import common from './common'
import HttpStatus from '@/components/http-status'
import { UniqError } from '@/models'
import cookie from '@/cookie'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_WEBAPI_URI
})

service.interceptors.request.use(
  config => {
    const jwtToken = cookie.get(cookie.tokenCookieName)
    setAuthHeader(config, jwtToken)
    config.headers.common['AppType'] = 'UNIQMS-IMAGEUPLOADER'
    // const hasAuthHeader = typeof config.headers.common['Authorization'] !== 'undefined'
    // if (token && !hasAuthHeader) {
    //   console.log('no token')
    //   setAuthHeader(config)
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add a response interceptor
service.interceptors.response.use(
  function(response) {
    return response
  },
  async function(error) {
    store.dispatch('$resetSpinner')
    const status = error.response ? error.response.status : ''
    const statusText = error.response ? error.response.statusText : ''
    const url = error.response ? error.response.config.url : ''
    let originalConfig = error.config
    originalConfig.url = originalConfig.url.replace(process.env.VUE_APP_WEBAPI_URI, '')
    if (
      (common.isExpiredToken(error) || common.isInvalidToken(error)) &&
      !originalConfig.url.includes('auth/imageuploader/signin') && !originalConfig.url.includes('auth/imageuploader/testConnection')
    ) {
      console.log('Refreshing token')
      const newToken = await refreshToken()
      if (newToken) {
        originalConfig.headers.Authorization = `Bearer ${newToken}`
        console.log('Submitting original request')
        return service.request(originalConfig)
      } else {
        return Promise.reject(error)
      }
    } else if (
      error &&
      error.response &&
      error.response.status &&
      error.response.status === HttpStatus.INTERNAL_SERVER_ERROR
    ) {
      let result = null
      if (error.response.data instanceof ArrayBuffer) {
        result = common.parseArrayBufferErrorResponse(error.response.data)
      } else {
        result = error.response.data
      }
      const e = new UniqError(result.id || 0, result.message || statusText, status, '', result.message)
      store.dispatch('errors/add', e)
      console.error(e)
      return Promise.reject(error)
    } else {
      const e = new UniqError(0, statusText, status, url, error.response.data)
      store.dispatch('errors/add', e)
      console.error(e)
      return Promise.reject(error)
    }
  }
)

/**
 * Set the Authorization header on a Axios Request.
 *
 * @param {Request} request The Axios Request instance to set the header on.
 * @return {void}
 */
function setAuthHeader(config, jwtToken) {
  config.headers.common['Authorization'] = `Bearer ${jwtToken}`
}

async function refreshToken() {
  try {
    const jwtToken = cookie.get(cookie.tokenCookieName)
    const result = await service.post('/auth/imageuploader/refreshtoken', `=${jwtToken}`)
    const newToken = result.data
    store.dispatch('setJwtToken', newToken)
    return newToken
  } catch (e) {
    if (e.request && e.request.status === HttpStatus.GONE) {
      console.error(e.request)
      cookie.delete(cookie.tokenCookieName)
      setTimeout(() => {
        router.push('/signin')
      }, 3000)
    }
    return ''
  }
}

export default service
